import React from 'react';

const HomePage = () => (
  <h1>This is the gallery home page</h1>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/client/components/home/index.js